import React, { FC, useEffect } from "react"
import { Route, useLocation } from "react-router-dom"
import { ROUTES } from "../../hooks/useNavigation"
import { makeStyles } from "@material-ui/core"
import Header from "../molecules/Header"
import Footer, { FooterHeight } from "../atoms/Footer"
import TechniquesAndInterventions from "./MyTechniquesAndInterventions"
import AccountSettings from "./AccountSettings"
import ClientDetail from "./ClientDetail"
import RiskAlertViewer from "./RiskAlertViewer"
import MyClients from "./MyClients"
import MyOrganization from "./MyOrganization"
import OrganizationSettings from "./OrganizationSettings"
import PractitionerDetail from "./PractitionerDetail"
import InsightViewer from "./InsightViewer"
import { useUser } from "../../hooks/useUser"
import {
  appInsightsWithOrg,
  clearAppInsightsContext,
} from "../../utils/AppInsights"
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js"
import { reactPlugin } from "../../utils/AppInsights"
import { withAITracking } from "@microsoft/applicationinsights-react-js"
import MyPractitioners from "./MyPractitioners"
import MyPractitionerClients from "./MyPractitionerClients"
import MyPractitionerClientDetail from "./MyPractitionerClientDetail"
import { useSession } from "../../hooks/useSession"
import useOrganizationFeatureFlags from "../../hooks/useOrganizationFeatureFlags"

const useStyles = makeStyles({
  privateRoutes: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: "100%",
    marginBottom: -FooterHeight,
    "&:after": {
      content: "",
      display: "block",
      height: FooterHeight,
    },
  },
  /**
   * Loop Client Detail: fill the viewport flex chain and never become a
   * second scrollport — LoopShell `.loop-shell-main` owns vertical scroll.
   */
  privateRoutesLoop: {
    display: "flex",
    flexDirection: "column",
    flex: "1 1 0",
    width: "100%",
    height: "100%",
    maxHeight: "100%",
    minHeight: 0,
    overflow: "hidden",
  },
})

export const PrivateRoutes: FC = () => {
  const classes = useStyles()
  const { user } = useUser()
  const { session } = useSession()
  const location = useLocation()
  const { showViraLoop } = useOrganizationFeatureFlags()
  const isRiskAlert = location.pathname.includes("risk-alert-detail")
  const isLoopClientDetail =
    showViraLoop && location.pathname.includes("client-detail")
  const hideChrome = isRiskAlert || isLoopClientDetail

  useEffect(() => {
    const firstOrganization = user?.organizations?.[0]

    if (firstOrganization && user?.id) {
      appInsightsWithOrg(
        `${firstOrganization.id}-${firstOrganization.name}`,
        `${user.id}`,
        session?.role,
        user?.isOrgAdmin
      )
    } else {
      clearAppInsightsContext()
    }

    return clearAppInsightsContext
  }, [session?.role, user])

  // We're using ts-expect-error here because the types for react-router-dom are not fully compatible with the way we're using it.
  // We'll need to fix this but for now it's working correctly. We'll revisit this when we spend time updating the web app.
  return (
    <AppInsightsContext.Provider value={reactPlugin}>
      <div
        className={
          isLoopClientDetail ? classes.privateRoutesLoop : classes.privateRoutes
        }
      >
        {!hideChrome && <Header />}
        {/* @ts-expect-error */}
        <Route path={ROUTES.ACCOUNT_SETTINGS}>
          <AccountSettings />
        </Route>
        {/* @ts-expect-error */}
        <Route path={ROUTES.MY_CLIENTS}>
          <MyClients />
        </Route>
        {/* @ts-expect-error */}
        <Route path={ROUTES.CLIENT_DETAIL}>
          <ClientDetail />
        </Route>
        {/* @ts-expect-error */}
        <Route path={ROUTES.TECHNIQUES_INTERVENTIONS}>
          <TechniquesAndInterventions />
        </Route>
        {/* @ts-expect-error */}
        <Route path={ROUTES.MY_ORG}>
          <MyOrganization />
        </Route>
        {/* @ts-expect-error */}
        <Route path={ROUTES.PRACTITIONER_DETAIL}>
          <PractitionerDetail />
        </Route>
        {/* @ts-expect-error */}
        <Route path={ROUTES.ORGANIZATION_SETTINGS}>
          <OrganizationSettings />
        </Route>
        {/* @ts-expect-error */}
        <Route path={ROUTES.INSIGHT_VIEWER}>
          <InsightViewer />
        </Route>
        {/* @ts-expect-error */}
        <Route path={ROUTES.RISK_ALERT_DETAIL}>
          <RiskAlertViewer />
        </Route>
        {/* @ts-expect-error */}
        <Route path={ROUTES.MY_PRACTITIONERS}>
          <MyPractitioners />
        </Route>
        {/* @ts-expect-error */}
        <Route path={ROUTES.SUPERVISOR_PRACTITIONER_CLIENTS}>
          <MyPractitionerClients />
        </Route>
        {/* @ts-expect-error */}
        <Route path={ROUTES.SUPERVISOR_PRACTITIONER_CLIENT_DETAIL}>
          <MyPractitionerClientDetail />
        </Route>
        {!hideChrome && <Footer />}
      </div>
    </AppInsightsContext.Provider>
  )
}

export default withAITracking(reactPlugin, PrivateRoutes)
//export default PrivateRoutes
